import React, { useState } from "react";
import { Controller } from "react-hook-form";
import { Col, Label, Row } from "reactstrap";
import { useGetRestaurantTypesQuery } from "../../redux/services/restaurantServices";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import './index.css';

interface ControlledRowTextFieldDropDownProps {
  label?: string;
  inputName: string;
  inputType: string;
  placeholder?: string;
  invalid?: boolean;
  control: any;
  rules?: object;
  errors?: any;
  register?: any;
  isRequired?: boolean;
  hasSideLabel?: boolean;
  sideLabel?: string;
  isDisabled?: boolean;
  defaultValue?: string;
  className?: string;
  value?: string | FileList;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  multiple?: boolean;
}

const ControlledRowTextFieldDropDown: React.FC<ControlledRowTextFieldDropDownProps> = ({
  label,
  inputName,
  placeholder,
  invalid,
  control,
  rules,
  errors,
  isRequired,
  hasSideLabel,
  sideLabel,
  isDisabled,
  defaultValue,
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(defaultValue || "");

  const { data, error } = useGetRestaurantTypesQuery("");

  const handleDropdownSelect = (value: string, setValue: any) => {
    setSelectedValue(value);
    setValue(value);
    setDropdownOpen(false);
  };

  if (error) return <div>Error:</div>;

  const types = data?.restaurantTypeList?.types || [];

  return (
    <div className="my-1">
      <Row>
        <Col lg="4">
          <Label className={`pt-1 form-label`} htmlFor={inputName}>
            {isRequired ? `${label} ` : label}
          </Label>
        </Col>
        <Col lg="7">
          <Controller
            name={inputName}
            control={control}
            rules={rules}
            render={({ field }) => (
              <>
                <Dropdown isOpen={dropdownOpen} toggle={() => setDropdownOpen(!dropdownOpen)}>
                  <DropdownToggle color="light" disabled={isDisabled} className="controlled-text-field-drop-down">
                    {selectedValue || placeholder}
                  </DropdownToggle>
                  <DropdownMenu>
                    {types.map((type: any, index: any) => (
                      <DropdownItem
                        key={index}
                        onClick={() => handleDropdownSelect(type.displayName, field.onChange)}
                      >
                        {type.displayName}
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </Dropdown>
                {hasSideLabel && <span className="ps-1 me-1">{sideLabel}</span>}
                {errors && errors[inputName] && (
                  <div className="invalid-feedback d-block">
                    {errors[inputName].message}
                  </div>
                )}
              </>
            )}
          />
        </Col>
      </Row>
    </div>
  );
};

export default ControlledRowTextFieldDropDown;

